import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M11.3334 10C11.7016 10 12 9.70153 12 9.33334C12 8.96515 11.7016 8.66667 11.3334 8.66667C10.9652 8.66667 10.6667 8.96515 10.6667 9.33334C10.6667 9.70153 10.9652 10 11.3334 10Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.33337 4.66667C1.33337 3.5621 2.2288 2.66667 3.33337 2.66667H10.6667C11.7713 2.66667 12.6667 3.5621 12.6667 4.66667V5.33334C13.7713 5.33334 14.6667 6.22877 14.6667 7.33334V12C14.6667 13.1046 13.7713 14 12.6667 14H3.33337C2.2288 14 1.33337 13.1046 1.33337 12V4.66667ZM11.3334 4.66667V5.33334H2.66671V4.66667C2.66671 4.29848 2.96518 4.00001 3.33337 4.00001H10.6667C11.0349 4.00001 11.3334 4.29848 11.3334 4.66667ZM2.66671 12V6.66667H12.6667C13.0349 6.66667 13.3334 6.96515 13.3334 7.33334V12C13.3334 12.3682 13.0349 12.6667 12.6667 12.6667H3.33337C2.96518 12.6667 2.66671 12.3682 2.66671 12Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}